<div class="modal-overlay" (click)="onOverlayClick()">
  <div class="modal-content" [ngClass]="modalClasses" [ngStyle]="modalStyles" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h3 class="fw-bold">{{ title }}</h3>
      <button type="button" class="modal-close-glass" (click)="close.emit()">
        <i class="ki-duotone ki-cross fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
    </div>

    <!-- Footer -->
    <div class="modal-footer" *ngIf="footerTemplate">
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </div>

  </div>
</div>